import { useQuery } from '@tanstack/react-query';
import { DocumentsService } from 'api';
import {
  FIRM_DOCUMENT_REQUESTED_FILES_QUERY_KEY,
  FIRM_DOCUMENT_REQUESTED_FILES_QUERY_STALE_TIME_MS,
} from './useFirmDocumentRequestedFilesQuery.constants';
import type { UseFirmDocumentRequestedFilesQueryParams } from './useFirmDocumentRequestedFilesQuery.types';

export const useFirmDocumentRequestedFilesQuery = ({
  companyId = null,
  enabled = true,
  firmId = null,
  measurementDateId = null,
}: UseFirmDocumentRequestedFilesQueryParams) => {
  const resolvedCompanyId = companyId ?? 0;
  const resolvedMeasurementDateId = measurementDateId ?? 0;

  return useQuery({
    enabled: Boolean(firmId && resolvedCompanyId && resolvedMeasurementDateId && enabled),
    queryFn: () => DocumentsService.apiDocumentsFirmsRequestedFilesList(
      String(firmId),
      resolvedCompanyId,
      resolvedMeasurementDateId
    ),
    queryKey: [
      FIRM_DOCUMENT_REQUESTED_FILES_QUERY_KEY,
      firmId ?? '',
      resolvedCompanyId || '',
      resolvedMeasurementDateId || '',
    ],
    staleTime: FIRM_DOCUMENT_REQUESTED_FILES_QUERY_STALE_TIME_MS,
  });
};
